import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "mysql",
  "name": "MySQL",
  "category": "database",
  "description": "Execute SQL queries and manage tables on MySQL databases",
  "icon": "siMysql",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "2.4.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "MySQL",
    "color": "#4479a1"
  },
  "credentials": [
    {
      "name": "mysql",
      "required": true,
      "displayName": "MySQL"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "mysql",
    "database",
    "sql",
    "query",
    "db"
  ],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'mysql_database',
    description: 'Execute SQL queries and operations on MySQL databases. Supports SELECT, INSERT, UPDATE, DELETE, bulk operations, and table management (create, drop, truncate, schema).',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The database operation to perform: executeQuery, insert, update, delete, createTable, bulkInsert, dropTable, truncateTable, tableExists, or getTableSchema',
        required: true,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'The SQL query to execute (for executeQuery operation)',
        required: false,
        type: 'string',
      },
      table: {
        toolParamName: 'table',
        description: 'The table name for table operations',
        required: false,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for createTable or bulkInsert operations',
        required: false,
        type: 'array',
      },
      parameters: {
        toolParamName: 'parameters',
        description: 'Query parameters as key-value pairs (use @paramName syntax)',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      rows: 'The query result rows or affected data',
      rowCount: 'Number of rows affected or returned',
      success: 'Whether the operation completed successfully',
      exists: 'Whether the table exists (for tableExists operation)',
      schema: 'Table schema information (for getTableSchema operation)',
    },
  },
};

export default definition;
